import { useCallback, useEffect, useState } from "react";
/** To be able to rerender input fields when one item in field array is removed or added, we need to know its length. When the length changes triger field rerender. */
import { getFieldArrayLength } from "../form-blocks/block-field-array/helpers";
import { useDebouncedCallback } from "use-debounce";
import { useField, useFormikContext } from "formik";
const DELAY = 400;
const MIN_BLOCK_SIZE_FOR_DELAY = 5;
const MIN_INPUT_FIELDS_FOR_DELAY = 5;
export const useDebounce = (fieldName, numberOfBlocks) => {
    const [innerValue, setInnerValue] = useState("");
    const { values } = useFormikContext();
    const [field] = useField(fieldName);
    /** We want to have delay only on very big forms and on very big pages. We don't need delay on small slides and blocks.  */
    const calculateAmountOfDelay = () => {
        if (numberOfBlocks && numberOfBlocks < MIN_BLOCK_SIZE_FOR_DELAY) {
            return 0;
        }
        else if (Object.keys(values)?.length < MIN_INPUT_FIELDS_FOR_DELAY) {
            return 0;
        }
        // Default is 400ms
        return DELAY;
    };
    const delay = calculateAmountOfDelay();
    useEffect(() => {
        setInnerValue(field.value);
    }, [field.value, getFieldArrayLength(values)]);
    const debouncedHandleOnChange = useDebouncedCallback(form => {
        form.setFieldValue(fieldName, innerValue, true);
    }, delay);
    const handleOnChange = useCallback((event, form, formatedFieldValues) => {
        event.persist();
        const newValue = formatedFieldValues ?? event.currentTarget.value;
        setInnerValue(newValue);
        debouncedHandleOnChange(form);
    }, []);
    return [innerValue, setInnerValue, handleOnChange];
};
